export default "__VITE_ASSET__ChswsTcs__"